const locale = {
  es: {
    translation: {
      BANNER_BUTTON: 'Ver detalles',
      COURSE_RECOMMENDATION: 'Cursos recomendados por la comunidad',
      COURSE_NEW: 'Cursos nuevos',
      COURSE_WATCH_MORE: 'Ver más cursos',
      COURSE_MEMBERSHIP_TITLE: 'Ten acceso total con Premium',
      COURSE_MEMBERSHIP_SUBTITLE:
        'Únete a nuestra comunidad Premium y accede a +500 cursos y +9 carreras.',
      COURSE_MEMBERSHIP_BUTTON: 'Me interesa',
      COURSE_CAREERS_TITLE: 'Especializaciones',
      COURSE_CAREERS_WATCH_MORE: 'Explora más expecializaciones',
      COURSE_CERTIFICATIONS_TITLE: 'Certificate',
      COURSE_CERTIICATIONS_WATCH_MORE: 'Explora más certificaciones',
      SHOW_ALL_COURSES: 'Mostrar todos los cursos',
      SEO_RECOMMENDED: 'Cursos recomendados por la comunidad',
      SEO_NEWS: 'Nuevos Cursos online',
      SEO_FREE: 'Cursos online gratis',
      SEO_DISCOUNT: 'Cursos en oferta',
      FILTER: 'Tus Filtros',
      SORT_BY: 'Ordenar',
      RESET_FILTERS: 'Limpiar',
      RETURN: 'Regresar',
      CLEAN_FILTERS: 'Limpiar Filtros',
      AD_TITLE1: '¡Aprovecha el ',
      AD_TITLE2: '% dto. en tu próxima compra!',
      AD_MIN_AMOUNT: 'Monto mínimo',
      AD_DESCRIPTION:
        'Tu descuento se aplicará en el momento de tu compra. Sólo aplica a cursos y certificaciones.',
      AD_BUTTON: 'Llévame al catálogo',
      BECOME_PREMIUM: 'Aprovecha',
      BECOME_PREMIUM_DESCRIPTION: 'Accede a todos estos cursos con rebajas',
    },
  },
};

export default locale;
